import router from '../router'
import store from '../store'

import { computed } from 'vue'
import { createAcl, defineAclRules } from 'vue-simple-acl'

const user = computed(() => store.state.auth.user)
// const user = {
//     id: 1,
//     name: 'Victory Osayi',
//     is_editor: true,
//     is_admin: false,
//     // you can have role based permission list or access control list possibly from database
//     permissions: ['admin', 'owner', 'moderator', 'create-post', 'edit-post', 'delete-post']
// }

const rules = () => defineAclRules((setRule) => {
    setRule('create-post', (user, post) => {
        return user.roles.includes(post.admin) || user.roles.includes(post.finance)
    })
    setRule('is-admin', (user) => user.is_admin)
    setRule('is-editor', (user) => user.is_editor)

    setRule('view-post', (user, post) => {
        return user.roles.includes(post.admin) || user.roles.includes(post.finance)
    })

    setRule('edit-post', (user, post) => {
        return user.roles.includes(post.admin)
    })
    setRule('delete-post', (user, post) => {
        return user.roles.includes(post.admin)
    })

    setRule(['publish-post', 'unpublish-post'], (user, post) => user.id === post.user_id)

    setRule('hide-comment', (user, post, comment) => {
        return user.is_admin || user.id === post.user_id || (user.id === comment.user_id && post.id === comment.post_id)
    })
    setRule('moderator', (user) => user.permissions && user.permissions.includes('moderator'))
})

const simpleAcl = createAcl({
    user,
    rules,
    router

})

export default simpleAcl
